<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="d-flex justify-start" cols="4" sm="4" md="1" lg="1" xl="1">
        <v-btn color="grey" small class="black--text" @click="toBack">前の日へ</v-btn>
      </v-col>
      <v-col class="d-flex justify-center" cols="4" sm="4" md="1" lg="1" xl="1">
        <v-btn color="grey" small class="black--text" @click="calendar">日付選択</v-btn>
      </v-col>
      <v-col class="hidden-md-and-up" style="text-align:right" cols="4" sm="4">
        <v-btn color="grey" small class="black--text" @click="toForward">次の日へ</v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="8" lg="8" xl="8">
        <Datepicker
          ref="picker"
          :monday-first="true"
          wrapper-class="calender-text-box-wrapper"
          input-class="calender-text-box"
          placeholder=""
          :language="dataPickLang"
          @selected=dateSelected />
        <v-card class="mx-auto text-center black--text" outlined>
          <div align="center">
            {{ yyyymmddDisp }}の出欠連絡
          </div>
        </v-card>
      </v-col>
      <v-col class="hidden-sm-and-down" style="text-align:right" md="2" lg="2" xl="2">
        <v-btn color="grey" small class="black--text" @click="toForward">次の日へ</v-btn>
      </v-col>
    </v-row>
    
    <!-- 検索条件 and 並び替え条件(モバイル用) -->
    <v-row dense class="d-sm-none">
      <v-col cols="6" class="d-flex justify-start">
        <div v-if="cancelCount > 0">
          出席：{{ cancelCount }}人
        </div>
      </v-col>
      <v-col cols="6" class="d-flex justify-end pr-2">
        <v-btn color="green" @click="filterDialog1 = true" small>
          <v-icon right dark v-if="isFilterFlg1">mdi-filter</v-icon>
          <v-icon right dark v-if="!isFilterFlg1">mdi-filter-outline</v-icon>
          フィルタ
        </v-btn>
      </v-col>
    </v-row>
    
    <!-- 検索条件 and 並び替え条件(PC用) -->
    <v-row dense class="hidden-xs-only">
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <!-- グループフィルタ -->
        <v-select
          v-model="groupFilterValue"
          label="グループ指定"
          :items="groupList"
          item-text="groupName"
          item-value="filterItem"
          outlined
          dense
          clearable
          multiple
          chips
          deletable-chips
          hide-details="auto"
          background-color="white"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <!-- 出欠区分フィルタ -->
        <v-select
          v-model="syukketuKbnFilterValue"
          label="出欠区分指定"
          :items="syukketuKbnList"
          outlined
          dense
          multiple
          chips
          deletable-chips
          hide-details="auto"
          background-color="white"
        ></v-select>
      </v-col>
      
      <v-col cols="0" sm="3" md="3" lg="3" xl="3" class="d-flex justify-start">
        <div v-if="cancelCount > 0">
          出席：{{ cancelCount }}人
        </div>
      </v-col>

      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <v-select
          label="並び順"
          :items="sortKbnList"
          item-text="text"
          item-value="value"
          v-model="sortKbn"
          outlined
          dense
          hide-details="auto"
          background-color="white"
        ></v-select>
      </v-col>
    </v-row>

    <!-- 明細表示 -->
    <v-row v-resize="updHeight">
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers"
          :items="members"
          :items-per-page="-1"
          :footer-props="{'disable-items-per-page': true}"
          dense
          disable-sort
          :height="tableHeight"
          :fixed-header="true"
          :loading="isListLoding" loading-text="読込中"
          mobile-breakpoint="0"
        >
          <!-- ラベル：最終更新日時 -->
          <template v-slot:top>
            <v-row dense>
              <v-col cols="12" class="d-flex text-caption justify-end">
                <div>最終更新時間：{{ lastReloadTime }}</div>
                <div v-if="isTodayFlg">(15分毎自動更新)</div>
                <div v-if="!isTodayFlg" style="color: red;">(自動更新停止中)</div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </template>
          <!-- ラベル：生徒氏名＋保護者連絡日時＋登録者名 -->
          <template #[`header.name`]="{}"> 
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                生徒氏名
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                保護者連絡日時
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                登録者名
              </v-col>
            </v-row>
          </template>
          <!-- ラベル：KBK学年学級 -->
          <template #[`header.filterItem`]="{}"> 
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                課程/部/科
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                学年/学級/出席番号
              </v-col>
            </v-row>
          </template>

          <!-- 生徒氏名と保護者連絡日時とモバイル用まとめセル -->
          <template #[`item.name`]="{ item }">
            <v-row no-gutters class="hidden-xs-only">
              <v-col cols="12" justify="center">
                <v-tooltip right v-if="item.createKbn == '1' && item.mailAddressAuthFlgParent">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on">mdi-email-outline</v-icon>
                  </template>
                  <span>保護者から連絡（メールアドレス設定済）</span>
                </v-tooltip>
                <v-tooltip right v-else-if="item.createKbn == '1' && !item.mailAddressAuthFlgParent">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on">mdi-phone</v-icon>
                  </template>
                  <span>保護者から連絡（メールアドレス未設定）</span>
                </v-tooltip>
                <v-tooltip right v-else-if="item.createKbn == '8'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on">mdi-human-male-board</v-icon>
                  </template>
                  <span>教員が出欠を登録</span>
                </v-tooltip>
                <v-tooltip right v-else-if="item.createKbn == '10'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on">mdi-barcode-scan</v-icon>
                  </template>
                  <span>バーコード受付で出欠を登録</span>
                </v-tooltip>
                <v-tooltip right v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on">mdi-file-outline</v-icon>
                  </template>
                  <span>出欠登録</span>
                </v-tooltip>
                {{ item.name }}
              </v-col>
            </v-row>
            <v-row no-gutters class="hidden-xs-only">
              <v-col cols="12" justify="center">
              {{ item.parentUpdDate }}
              </v-col>
            </v-row>
            <v-row no-gutters class="hidden-xs-only">
              <v-col cols="12" justify="center">
                <span v-if="item.createUserFlg" class="text-caption red--text">
                  {{ item.createUserNm }}
                </span>
                <span v-if="!item.createUserFlg" class="text-caption black--text">
                  {{ item.createUserNm }}
                </span>
              </v-col>
            </v-row>

            <!-- モバイル用まとめ -->
            <v-row dense class="d-sm-none">
              <v-col cols="12" justify="center">
                <!-- １行目（生徒氏名＋KBK学年学級出席番号） -->
                <v-row no-gutters>
                  <v-col cols="5" class="d-flex text-subtitle-1">
                    {{ item.name }}
                  </v-col>
                  <v-col cols="7" class="d-flex justify-end text-caption">
                    {{ item.buNm }}/{{ item.kaNm }}/{{ item.gakunen }}/{{ item.gakkyu }}/{{ item.syussekiNo }}
                  </v-col>
                </v-row>
                <!-- ２行目（通用門通過時刻＋出欠区分＋保護者更新日時） -->
                <v-row no-gutters>
                  <v-col cols="4" class="d-flex text-subtitle-1">
                    <span v-if="item.gatePassageTime">{{ item.gatePassageTime }}：</span>{{ item.syukketuNm }}
                  </v-col>
                  <v-col cols="8" class="d-flex justify-end text-caption">
                    保護者更新：{{ item.parentUpdDate }}
                  </v-col>
                </v-row>
                <!-- ３行目（備考） -->
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex text-caption">
                    {{ item.biko }}
                  </v-col>
                </v-row>
                <!-- ４行目（登録者） -->
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex text-caption">
                    登録者：
                    <span v-if="item.createUserFlg" class="text-caption red--text">
                      {{ item.createUserNm }}
                    </span>
                    <span v-if="!item.createUserFlg" class="text-caption black--text">
                      {{ item.createUserNm }}
                    </span>
                  </v-col>
                </v-row>
                <!-- ５行目（ボタン類） -->
                <v-row no-gutters>
                  <v-col cols="2" class="d-flex text-caption">
                    <v-btn color="accent" small class="black--text" @click="onClickReadItem(item)" :disabled="lockConfirmButton(item)">確認</v-btn>
                  </v-col>
                  <v-col cols="3" class="d-flex text-caption">
                    <div v-if="item.readSchoolFlg">確認済</div>
                    <div v-else>未確認</div>
                  </v-col>
                  <v-col cols="2" class="d-flex text-caption">
                    <v-btn color="accent" small class="black--text" @click="onClickSyukketu(item)" :disabled="item.pastLockFlg">返信</v-btn>
                  </v-col>
                  <v-col cols="2" class="d-flex text-caption">
                    <v-btn color="accent" small class="black--text" @click="onClickSyukketuApproval(item)" :disabled="item.pastLockFlg">確定</v-btn>
                  </v-col>
                  <v-col cols="3" class="d-flex text-caption">
                    <v-icon class="ml-2" v-if="item.approvalFlg">mdi-check-outline</v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>

          <!-- KBK学年学級 -->
          <template #[`item.filterItem`]="{ item }">
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                {{ item.kateiNm }}/{{ item.buNm }}/{{ item.kaNm }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" justify="center">
                {{ item.gakunen }}/{{ item.gakkyu }}/{{ item.syussekiNo }}
              </v-col>
            </v-row>
          </template>

          <!-- 出欠確認 -->
          <template #[`item.readSchoolFlg`]="{ item }">
            <div v-if="item.readSchoolFlg">確認済</div>
            <div v-else>未確認</div>
          </template>

          <!-- 出欠区分名 -->
          <template #[`item.syukketuKbn`]="{ item }">
            {{ item.syukketuNm }}
          </template>

          <!-- 確認ボタン -->
          <template #[`item.action0`]="{ item }">
            <v-btn color="accent" class="black--text" @click="onClickReadItem(item)" :disabled="lockConfirmButton(item)">確認</v-btn>
          </template>

          <!-- 返信ボタン -->
          <template #[`item.action1`]="{ item }">
            <v-btn color="accent" class="black--text" @click="onClickSyukketu(item)" :disabled="item.pastLockFlg">返信</v-btn>
          </template>

          <!-- 確定状況 -->
          <template #[`item.approvalFlg`]="{ item }">
            <v-icon class="ml-2" v-if="item.approvalFlg">mdi-check-outline</v-icon>
          </template>

          <!-- 確定ボタン -->
          <template #[`item.action2`]="{ item }">
            <v-btn color="accent" class="black--text" @click="onClickSyukketuApproval(item)" :disabled="item.pastLockFlg">確定</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" fixed fab bottom color="secondary" @click="reload" style="bottom: 50px">
          <v-icon color="white">mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>再読込</span>
    </v-tooltip>

    <!-- フィルタモーダル -->
    <v-dialog
      v-model="filterDialog1"
      persistent
      max-width="600"
    >
      <v-card
        class="d-flex justify-center flex-column mx-auto flat"
        width="600"
        color="#fff"
      >
        <v-card-title class="d-flex pt-3 justify-center" white-space="pre">
          <v-row dense>
            <v-col dense cols="4" justify="center">
              <v-btn color="grey" class="black--text" @click="clearFilter1" width="90%">
                クリア
              </v-btn>
            </v-col>
            <v-col dense cols="4" justify="center">
              <p>フィルタ</p>
            </v-col>
            <v-col dense cols="4" justify="center">
              <v-btn color="accent" class="black--text" @click="doFilter1" width="90%">
                適用
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="d-flex justify-center flex-column">
          <v-row dense>
            <v-col cols="12">
              <!-- グループフィルタ -->
              <v-select
                v-model="groupFilterValue"
                label="グループ指定"
                :items="groupList"
                item-text="groupName"
                item-value="filterItem"
                outlined
                dense
                clearable
                multiple
                chips
                deletable-chips
                hide-details="auto"
                background-color="white"
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <!-- 出欠区分フィルタ -->
              <v-select
                v-model="syukketuKbnFilterValue"
                label="出欠区分指定"
                :items="syukketuKbnList"
                outlined
                dense
                clearable
                multiple
                chips
                deletable-chips
                hide-details="auto"
                background-color="white"
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-select
                label="並び順"
                :items="sortKbnList"
                item-text="text"
                item-value="value"
                v-model="sortKbn"
                outlined
                dense
                hide-details="auto"
                background-color="white"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <!-- 出欠修正ダイアログ -->
    <v-dialog
      v-model="syukketuDialog"
      max-width="500"
      min-height="490"
      max-height="490"
      persistent
      scrollable
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
        min-height="490"
      >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="syukketuDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              出欠登録({{ this.syukketuStudentNm }})
            </v-col>
            <v-col cols="2" justify="center">
            </v-col>
          </v-row>
        </v-card-actions>
        <AttendanceEdit
          v-if="syukketuDialog"
          :studentId=syukketuStudentId
          :param_yyyymmdd=yyyymmdd
          @changeSyukketu="changeSyukketu"
        />
      </v-card>
    </v-dialog>

    <!-- 出欠確定モーダル -->
    <v-dialog
      v-model="attendanceApprovalDialog"
      max-width="500"
      min-height="260"
      max-height="260"
      persistent
      scrollable
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
        min-height="260"
      >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="attendanceApprovalDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              出欠確定({{ this.approvalStudentNm }})
            </v-col>
            <v-col cols="2" justify="center">
            </v-col>
          </v-row>
        </v-card-actions>
        <AttendanceApproval
          v-if="attendanceApprovalDialog"
          :studentId=approvalStudentId
          :param_yyyymmdd=yyyymmdd
          @changeSyukketuApproval="changeSyukketuApproval"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { ja as dataPickLang } from 'vuejs-datepicker/dist/locale';
import { httpsCallable, getFunctions } from "firebase/functions";
import { format, parse } from 'date-fns';
import { ja } from 'date-fns/locale';
import Enumerable from "linq";
import AttendanceEdit from './components/AttendanceEdit.vue'
import AttendanceApproval from './components/AttendanceApproval.vue'

export default {
  props: ['param_yyyymmdd'],
  components: {
    AttendanceEdit,
    AttendanceApproval,
  },
  watch: {
    yyyymmdd: async function(newVal, oldVal) {
      // 本日判定
      var today = format(new Date(), 'yyyy-MM-dd', { locale: ja });
      console.log(today, newVal, oldVal)
      this.isTodayFlg = (today == newVal)?true:false;
      await this.reload();
    },
    // ソート順変更時のソート
    sortKbn: async function(newVal, oldVal) {
      console.log(newVal, oldVal);
      if(newVal == "1") {
        this.members = Enumerable.from(this.membersBase).orderBy((x) => { return x.orderNoKBKGCS }).toArray();
      } else if(newVal == "2") {
        this.members = Enumerable.from(this.membersBase).orderByDescending((x) => { return x.parentUpdDateTime }).toArray();
      } else if(newVal == "3") {
        this.members = Enumerable.from(this.membersBase).orderByDescending((x) => { return x.orderNoKBKGCS }).toArray();
      } else if(newVal == "4") {
        this.members = Enumerable.from(this.membersBase).orderBy((x) => { return x.parentUpdDateTime }).toArray();
      }
      this.$store.dispatch('setSortCondition_AttendanceConfirm', newVal);
    },
    groupFilterValue: function(newVal) {this.$store.dispatch('setSearchConditionSyukketuGroup', newVal)},
    syukketuKbnFilterValue: function(newVal) {this.$store.dispatch('setSearchConditionSyukketuKbn', newVal)},
  },
  data() {
    return {
      dataPickLang: dataPickLang,
      // フィルタ用
      filterDialog1: false,
      isFilterFlg1: false,

      yyyymmdd: "",
      yyyymmddDisp: "",
      isTodayFlg: false,
      headers: [
        { text: "生徒氏名 連絡日時", value: "name", class: "hidden-xs-only", width: "20%" },
        { text: "課程/部/科 学年/学級/出席番号", value: "filterItem", class: "hidden-xs-only", cellClass: "hidden-xs-only", width: "20%", filter: this.groupFilter },
        { text: "通用門通過", value: "gatePassageTime", class: "hidden-xs-only", cellClass: "hidden-xs-only", width: "8%" },
        { text: "出欠区分", value: "syukketuKbn", class: "hidden-xs-only", cellClass: "hidden-xs-only", width: "60px", filter: this.syukketuKbnFilter },
        { text: "備考", value: "biko", class: "hidden-xs-only", cellClass: "hidden-xs-only" },
        { text: "出欠確認", value: "readSchoolFlg", class: "hidden-xs-only", cellClass: "hidden-xs-only", width: "5%" },
        { text: "", value: "action0", class: "hidden-xs-only", cellClass: "hidden-xs-only", width: "5%" },
        { text: "", value: "action1", class: "hidden-xs-only", cellClass: "hidden-xs-only", width: "5%" },
        { text: "出欠確定", value: "approvalFlg", class: "hidden-xs-only", cellClass: "hidden-xs-only", width: "5%" },
        { text: "", value: "action2", class: "hidden-xs-only", cellClass: "hidden-xs-only", width: "5%" },
      ],
      
      // 検索直後のデータ
      membersBase: [],
      // ソートした後のデータ
      members: [],
      // ソート用区分
      sortKbn: "1",
      sortKbnList: [
        {value:"1", text:"学年/学級/出席番号(昇順)"},
        {value:"2", text:"保護者連絡日時(降順)"},
        {value:"3", text:"学年/学級/出席番号(降順)"},
        {value:"4", text:"保護者連絡日時(昇順)"},
      ],
      isListLoding: false,
      language:{
        language: 'Japanese',
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        monthsAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        days: ['日', '月', '火', '水', '木', '金', '土'],
        yearSuffix: '年',
        ymd: true,
      },
      groupFilterValue: [],
      groupList: [],
      syukketuKbnFilterValue: [ 1, 5 ],
      syukketuKbnList: [
        { text: "出席", value: 0 },
        { text: "欠席", value: 1 },
        { text: "遅刻", value: 5 }
      ],

      // 早退予定者数
      cancelCount: 0,
      // v-data-table 高さ
      tableHeight: 0,  

      // 出欠修正用
      syukketuDialog: false,
      syukketuStudentId: "",
      syukketuStudentNm: "",
      // 出欠確定用
      attendanceApprovalDialog: false,
      approvalStudentId: "",
      approvalStudentNm: "",

      // 一覧の定期更新用
      intervalid1:"",
      lastReloadTime:"",
    };
  },
  // 初期表示時データ読み込み
  async created() {
    var date = parse(this.param_yyyymmdd, 'yyyy-MM-dd', new Date());
    this.yyyymmdd = format(date, 'yyyy-MM-dd', { locale: ja });
    this.yyyymmddDisp = format(date, 'yyyy年M月d日(E)', { locale: ja });

    this.sortKbn = this.$store.state.sortCondition_AttendanceConfirm;

    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
    schoolAidHomeLogined({funcName: "getSyukketuGroup"}).then((ret) => {
      this.groupList = ret.data;
      this.groupFilterValue = this.$store.state.searchConditionSyukketuGroup;
      
      // 保持グループの中で所属していないグループが一件でもあればクリア
      for (const fGroup of this.groupFilterValue) {
        var tmpList = this.groupList.filter(e => e.filterItem == fGroup);
        if (tmpList.length == 0) {
          this.groupFilterValue = "";
          break;
        }
      }
    });
    this.syukketuKbnFilterValue = this.$store.state.searchConditionSyukketuKbn;

    await this.reload();

    // 定期更新の設定
    this.intervalid1 = setInterval(() => {
      // 日付またぎ制御
      // 24時～25時に指定日付の翌日＝システム日付であった場合、指定日付を当日にセット
      if (format(new Date(),"HH") == "00") {
        var tomorrow = parse(this.yyyymmdd, 'yyyy-MM-dd', new Date());
        tomorrow.setDate(tomorrow.getDate() + 1);
        var today = new Date();
        
        if (format(tomorrow,"yyyy-MM-dd") == format(today,"yyyy-MM-dd")) {
          // 日付をまたいだ場合指定日に当日をセット
          this.yyyymmdd = format(today, 'yyyy-MM-dd', { locale: ja });
          this.yyyymmddDisp = format(today, 'yyyy年M月d日(E)', { locale: ja });
        }
      }

      // 当日のみ更新
      if(this.isTodayFlg) {
        this.reload();
      }
    }, 900000);
  },
  beforeDestroy () {
    // 定期更新の設定破棄
    clearInterval(this.intervalid1)
  },
  methods: {
    // ページ再読込
    async reload() {
      this.members = [];

      var param = {
        funcName: "loadAttendanceConfirm",
        yyyymmdd: this.yyyymmdd
      }

      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      this.isListLoding = true;
      await schoolAidHomeLogined(param).then((syukketus) => {
        var ret = [];
        syukketus.data.forEach((syukketu) => {
          // 出欠区分の日本語変換
          let syukketuKbn = syukketu.syukketuKbn;
          let syukketuNm = "";
          if (syukketuKbn === 0) {
            syukketuNm = "";
          } else if (syukketuKbn === 1) {
            syukketuNm = "欠席";
          } else if (syukketuKbn === 5) {
            syukketuNm = "遅刻";
          } else if (syukketuKbn === 6) {
            syukketuNm = "早退予定";
          }
          let createUserKbn = syukketu.createUserKbn;
          let createUserFlg = false;
          if(createUserKbn == "8"){
            createUserFlg = true;
          }

          var row = {
            mailAddressAuthFlg: syukketu.mailAddressAuthFlg,
            name : syukketu.name,
            mailAddressAuthFlgParent: syukketu.mailAddressAuthFlgParent,
            parentName : syukketu.parentName,
            filterItem : syukketu.filterItem,
            kateiNm: syukketu.kateiNm,
            buNm: syukketu.buNm,
            kaNm: syukketu.kaNm,
            gakunen: syukketu.gakunen,
            gakkyu: syukketu.gakkyu,
            syussekiNo: syukketu.syussekiNo,
            syukketuKbn: syukketu.syukketuKbn,
            syukketuNm: syukketuNm,
            biko: syukketu.biko,
            createUserNm: syukketu.createUserNm,
            createUserFlg: createUserFlg,
            readSchoolFlg: (syukketu.readSchoolFlg == true) ? true : false,
            approvalFlg: (syukketu.approvalFlg == true) ? true : false,
            loginId: syukketu.loginId,
            pastLockFlg: syukketu.pastLockFlg,
            gatePassageTime: syukketu.gatePassageTime,
            gatePassageFlg: syukketu.gatePassageFlg,
            parentUpdDate: syukketu.parentUpdDate,
            parentUpdDateTime: syukketu.parentUpdDateTime,
            orderNoKBKGCS: syukketu.orderNoKBKGCS,
            createKbn: syukketu.createKbn,
          };
          console.log("syukketu.createKbn", syukketu.createKbn);
          ret.push(row);
        });
        this.membersBase = ret;
        if(this.sortKbn == "1") {
          this.members = Enumerable.from(ret).orderBy((x) => { return x.orderNoKBKGCS }).toArray();
        } else if(this.sortKbn == "2") {
          this.members = Enumerable.from(ret).orderByDescending((x) => { return x.parentUpdDateTime }).toArray();
        } else if(this.sortKbn == "3") {
          this.members = Enumerable.from(ret).orderByDescending((x) => { return x.orderNoKBKGCS }).toArray();
        } else if(this.sortKbn == "4") {
          this.members = Enumerable.from(ret).orderBy((x) => { return x.parentUpdDateTime }).toArray();
        }

        this.isListLoding = false;
      }).catch((e) =>{
        console.log(e.message);
        this.error = e.message;
        this.$root.loading = false;
      });

      // 出席数のカウント用
      var syussekiList = Enumerable.from(this.membersBase).where(i => i.syukketuKbn == 0).toArray();
      this.cancelCount = syussekiList.length;
      this.lastReloadTime = format(new Date(), "HH時mm分ss秒", { locale: ja });
    },
    // ************************* 検索条件部 start *************************
    // グループフィルタ
    groupFilter(value) {
      if (this.groupFilterValue.length == 0) {
        return true;
      }
      return this.groupFilterValue.includes(String(value));
    },
    // 出欠区分フィルタ
    syukketuKbnFilter(value) {
      if (this.syukketuKbnFilterValue.length == 0) {
        return true;
      }
      return this.syukketuKbnFilterValue.includes(value);
    },
    // データピッカー開閉
    calendar() {
        if(!this.$refs.picker.isOpen) {
            this.$refs.picker.$el.querySelector("input").focus();
            this.$refs.picker.showCalendar();
        } else {
            this.$refs.picker.close();
        }
    },
    // データピッカー日付選択
    dateSelected(selectedDate) {
        this.yyyymmdd = format(selectedDate, 'yyyy-MM-dd', { locale: ja });
        this.yyyymmddDisp = format(selectedDate, 'yyyy年M月d日(E)', { locale: ja });
    },
    // 前の日へボタン
    toBack() {
      var date = parse(this.yyyymmdd, 'yyyy-MM-dd', new Date());
      date.setDate(date.getDate() - 1);
      this.yyyymmdd = format(date, 'yyyy-MM-dd', { locale: ja });
      this.yyyymmddDisp = format(date, 'yyyy年M月d日(E)', { locale: ja });
    },
    // 次の日へボタン
    toForward() {
      var date = parse(this.yyyymmdd, 'yyyy-MM-dd', new Date());
      date.setDate(date.getDate() + 1);
      this.yyyymmdd = format(date, 'yyyy-MM-dd', { locale: ja });
      this.yyyymmddDisp = format(date, 'yyyy年M月d日(E)', { locale: ja });
    },
    // ************************* 検索条件部 end *************************
    // ************************* 出欠訂正・確定部 start *************************
    // 出欠訂正モーダル呼出
    onClickSyukketu(item) {
      this.syukketuStudentId = item.loginId;
      this.syukketuStudentNm = item.name;
      this.syukketuDialog = true;
    },
    // 出欠訂正モーダルからのフィードバック
    async changeSyukketu(uid, syukketuKbn, syukketuKbnNm) {
      console.log("changeSyukketu", uid, syukketuKbn, syukketuKbnNm);
      await this.reload();
      this.syukketuDialog = false;
    },
    // 出欠確定モーダル呼出
    onClickSyukketuApproval(item) {
      this.approvalStudentId = item.loginId;
      this.approvalStudentNm = item.name;
      this.attendanceApprovalDialog = true;
    },
    // 出欠確定モーダルからのフィードバック
    changeSyukketuApproval(uid, approvalFlg, approvalKbnNm) {
      console.log("changeSyukketuApproval", uid, approvalFlg, approvalKbnNm);
      for(const row of this.members){
        if(row.loginId == uid){
          row.approvalFlg = approvalFlg;
        }
      }
      for(const row of this.membersBase){
        if(row.loginId == uid){
          row.approvalFlg = approvalFlg;
        }
      }
      this.attendanceApprovalDialog = false;
    },
    // ************************* 出欠訂正・確定部 end *************************
    // 出欠確認ボタン制御
    lockConfirmButton(item) {
      // 学期開始日前であればロック
      if(item.pastLockFlg)return true;
      // 当日でなければロック
      if(!this.isTodayFlg)return true;
      // 確認済であればロック
      if(item.readSchoolFlg)return true;
      // 通用門受付で登録されたデータであればロック
      if(item.gatePassageFlg)return true;
      return false;
    },
    // 出欠確認ボタン押下時制御
    async onClickReadItem(item) {
      var param = {
        funcName: "updateReadSchoolFlg",
        yyyymmdd: this.yyyymmdd,
        studentId: item.loginId,
      }

      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        if(ret.data == "success"){
          item.readSchoolFlg = true;
        }
      });
    },
    // データテーブルの高さ制御
    updHeight(){
      this.tableHeight = parseInt(window.innerHeight * 0.6);
    },

    // 検索モーダル用 =================================================================================
    doFilter1() {
      this.isFilterFlg1 = true;
      this.filterDialog1 = false;
    },
    clearFilter1(){
      this.groupFilterValue = "";
      this.syukketuKbnFilterValue = [ 1, 5 ];

      this.isFilterFlg1 = false;
      this.filterDialog1 = false;
    },
  },
};
</script>

<style scoped>
.calender-text-box {
    display: none;
}
.vdp-datepicker__calendar {
    width: 350px !important;
}
</style>